import {
  isAssemblyOfflinePackageFile,
  normalizeImportedAssetFileId,
  type ModelAssetFile,
} from '@puppycad/cad-core'

/**
 * 生成不依赖 nodeKey 的文件身份 key。
 *
 * 设计说明：cad-core 的 `ModelAssetReader` 只接收 file，本身不携带 nodeKey，因此内存 reader 必须使用
 * 版本文件 URL 区分不同仓库/提交下同名的 `_assembly.json`。
 *
 * @param file 需要索引的版本文件。
 * @returns 可供内存 reader 查找字节的唯一 key。
 */
export function buildProjectAssetFileIdentityKey(file: ModelAssetFile): string {
  return `${file.role}::${file.url}::${file.uuid || file.fileId}::${file.fileId}`
}

/**
 * 判断项目模型文件是否是 `.puppy` 离线包。
 *
 * 设计说明：OpenProject 的 CadNode 判断以 fileId/kind 命中 `.puppy` 为离线包依据；项目模型进入
 * ModelAssetNode 后必须沿用同一语义，避免节点版本切换和项目级打开出现两套判断。
 *
 * @param file 项目模型文件描述。
 * @returns 文件类型或文件路径指向 `.puppy` 时返回 true。
 */
export function isPuppyPackageModelAssetFile(file: ModelAssetFile): boolean {
  // 完整 GLB 包只复用 ZIP 容器，不具备标准 Puppy package/project-model 身份协议。
  if (file.loadMode === 'complete-glb-scene') {
    return false
  }

  return isAssemblyOfflinePackageFile({
    fileId: normalizeImportedAssetFileId(file.fileId),
    uuid: file.uuid,
    kind: file.kind,
  })
}
